import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const AllZoomStudentEmails = lazy(() => import('../../container/all-student-domain-emails/students-emails'));
const StudentZoom = lazy(() => import('../../container/all-student-domain-emails/students-zoom'));

const AllTeacherEmails = lazy(() => import('../../container/all-teachers-domain-emails'));
const AllOfficialEmails = lazy(() => import('../../container/all-official-domain-emails'));
const TeacherZoom = lazy(() => import('../../container/teachers-zoom'));

const TeacherEmails = lazy(() => import('../../container/domain-emails'));
const StudentEmails = lazy(() => import('../../container/domain-student-emails'));
const ClassTeacherZoomEmails = lazy(() => import('../../container/domain-class-teacher-zoom-emails'));
const AllClassTeacherZoomEmails = lazy(() => import('../../container/domain-all-class-teacher-zoom-emails'));

const DomainEmailRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/zoom-students`} component={StudentZoom}/>
            <Route path={`${path}/all-zoom-students`} component={AllZoomStudentEmails}/>

            <Route path={`${path}/zoom-teachers`} component={TeacherZoom}/>
            <Route path={`${path}/all-teachers`} component={AllTeacherEmails}/>

            <Route path={`${path}/all-official`} component={AllOfficialEmails}/>

            <Route path={`${path}/teachers`} component={TeacherEmails}/>
            <Route path={`${path}/students`} component={StudentEmails}/>
            <Route path={`${path}/class-teacher-zoom-email`} component={ClassTeacherZoomEmails}/>
            <Route path={`${path}/all-class-teacher-zoom-email`} component={AllClassTeacherZoomEmails}/>
        </Switch>
    );
};

export default DomainEmailRoutes;